import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_ATS_API_URL } from "../../../../Constants/baseConstant";
import { getUserData } from "../../../Base/helper/baseFunctions";

export const GetAtsDesignationHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/ats/ancillary/getAtsDesignations`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: params?.domain ? params?.domain : data?.domain
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed", hasError: true, data: err?.data }
        })
}

export const AddAtsDesignationHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/ats/ancillary/addAtsDesignation`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: data?.domain || params?.domain,
            user_emp_id: data?.employee_id || 0,
            name: params?.name || params?.designation,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Designation Added Successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Failed", hasError: true, data: err?.data }
        })
}

export const UpdateAtsDesignationHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Saving...")
    return await axiosInstance(`/ats/ancillary/updateAtsDesignation`, {
        method: "PUT",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: data?.domain,
            user_emp_id: data.employee_id,
            designation_id: params?.ats_designation_id,
            name: params?.name,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Designation Updated Successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Failed", hasError: true, data: err?.data }
        })
}

export const DeleteAtsDesignationHelper = async (params) => {
    const data = getUserData();
    toast.dismiss();
    toast.info("Deleting...")
    return await axiosInstance(`/ats/ancillary/deleteAtsDesignation`, {
        method: "DELETE",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: data?.domain,
            designation_id: params?.designation_id
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Designation Deleted Successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message);
            return { message: "Failed", hasError: true, data: err?.data }
        })
}